/*
 * @Author: syyoon@yongtrim.com
 * @Date: 2019-01-22 00:27:22
 * @Last Modified by: syyoon@yongtrim.com
 * @Last Modified time: 2019-01-24 00:44:30
 */

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ENV } from "../env/env";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Watch } from "../models/watch.model";
import { TransService } from "./trans.service";

@Injectable()
export class WatchService {
  private url = `${ENV.SERVER_URL}/${ENV.API_PATH}/watches`;

  private _updatedWatch: BehaviorSubject<Watch> = new BehaviorSubject(null);

  constructor(private transService: TransService, private http: HttpClient) {}

  createWatch(data) {
    return this.http.post(`${this.url}`, data);
  }

  getWatches(page: number, limit: number, channelId: string, type?: string) {
    return this.http.get(
      `${this.url}?page=${page}&limit=${limit}&type=${type ||
        ""}&channel=${channelId || ""}&lang=${this.transService.lang}`
    );
  }

  getWatch(id: string) {
    return this.http.get(`${this.url}/${id}?lang=${this.transService.lang}`);
  }

  updateWatch(id: string, data) {
    return this.http.put(
      `${this.url}/${id}?lang=${this.transService.lang}`,
      data
    );
  }

  deleteWatch(id: string) {
    return this.http.delete(`${this.url}/${id}?lang=${this.transService.lang}`);
  }

  setChannel(id: string, channelId: string) {
    return this.http.put(
      `${this.url}/${id}/set-channel?lang=${this.transService.lang}`,
      {
        channel: channelId
      }
    );
  }

  views(id: string) {
    return this.http.get(
      `${this.url}/${id}/views?lang=${this.transService.lang}`
    );
  }

  paids(id: string) {
    return this.http.get(
      `${this.url}/${id}/paids?lang=${this.transService.lang}`
    );
  }

  notifyUpdatedWatch(watch: Watch) {
    this._updatedWatch.next(watch);
  }

  get updatedWatch$() {
    return this._updatedWatch.asObservable();
  }

  syncVimeo(id: string) {
    return this.http.get(
      `${this.url}/${id}/sync-vimeo?lang=${this.transService.lang}`
    );
  }

  bookmarkWatch(id: string, enable: boolean) {
    return this.http.put(
      `${this.url}/${id}/bookmark?lang=${this.transService.lang}`,
      {
        enable: enable
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/services/watch.service.ts